import { z } from 'zod'

import { PSYCHIATRY_STEP_SLUG, SKIP_SERVICE_STEP_SLUG } from '@/legacy-src/components/diagnosis/client/constants'
import { DiagnosisGuideSteps } from '@/legacy-src/components/diagnosis/client/types'

import { AgeGroup, Gender, PartOfDay } from '@/src/domains/diagnosis/constants'

export const DiagnosisStepSlugSchema = z.union([
  z.coerce.number().pipe(z.nativeEnum(DiagnosisGuideSteps)),
  z.literal(PSYCHIATRY_STEP_SLUG),
  z.literal(SKIP_SERVICE_STEP_SLUG),
])

// Enum schemas
const TherapistAgeGroupSchema = z.nativeEnum(AgeGroup).nullable()
const PartOfDaySchema = z.nativeEnum(PartOfDay)

// TherapistMatch schema - based on getRecommendedTherapists return type
export const TherapistMatchSchema = z.object({
  therapistId: z.number().int(),
  ageGroup: TherapistAgeGroupSchema,
  partsOfDay: z.array(PartOfDaySchema),
  styleMatch: z.number().int().min(0).max(100),
})

// Diagnosis schema - based on getPublicAttributes() method
export const DiagnosisSchema = z.object({
  id: z.number().int(),
  lead: z.number().int(),
  emotions: z.number().int(),
  past: z.number().int(),
  personality: z.number().int(),
  sex: z.nativeEnum(Gender).nullable(),
  specialization: z.array(z.number().int()),
  services: z.array(z.number().int()),
  goal: z.number().int().nullable(),
  userId: z.number().int(),
  therapyExperience: z.number().int().nullable(),
  therapyActivities: z.array(z.number().int()).nullable(),
  therapyFrequency: z.number().int().nullable(),
  therapistAgeGroup: z.nativeEnum(AgeGroup).nullable(),
  maxPrice: z.number().int().nullable(),
  insuranceId: z.number().int().nullable(),
  partOfDay: z.nativeEnum(PartOfDay).nullable(),
  language: z.string().nullable(),
  sessionType: z.number().int().nullish(),
  sessionOfficeDistrictIds: z.array(z.number().int()).nullish(),
  insurance: z
    .object({
      id: z.number().int(),
    })
    .nullable()
    .optional(),
})

// Main GET diagnosis response schema
export const GetDiagnosisResponseSchema = z.object({
  diagnosis: DiagnosisSchema.optional(),
  therapistMatches: z.array(TherapistMatchSchema).optional(),
  therapists: z.array(z.number().int()).optional(),
})
